import { Panel, PanelType } from "@fluentui/react";
import React from "react";
import { useSelector } from "react-redux";
import AdvancedSearch from "../../advancedSearch/advancedSearch";
import { RootState } from "../../src/taskpane/components/_v2/redux/storeMain";
import generalModule from "../../utilities/GeneralModule";

export interface ICMFilterPanelProps {
  panelIsOpen: boolean;
  closePanel: () => void;
}

export const CMFAdvancedSearchPanel = ({ panelIsOpen, closePanel }: ICMFilterPanelProps) => {
  const currentDirectory = useSelector((state: RootState) => state.workingDirectories.workingDirectories.length > 0 ? state.workingDirectories.workingDirectories[state.workingDirectories.workingDirectories.length - 1] : null);
  const account = useSelector((state: RootState) => state.user.account);
  
  return (
    <Panel
      isOpen={panelIsOpen}
      onDismiss={() => closePanel()}
      isLightDismiss
      closeButtonAriaLabel="Close"
      type={PanelType.custom}
      customWidth={'95%'}
    >
          <AdvancedSearch account={account} siteId={currentDirectory?.siteId} isInConentMangerMode={generalModule.isInConentMangerMode()}/>
    </Panel>

  )
};